import moment from 'moment-timezone';
export const DataTimezones = moment.tz.names();
export const DataTimezonesSelectValues = DataTimezones.map((z) => ({ label: z, value: z }));
//# sourceMappingURL=timezones.js.map